import React from 'react';
import { Knowledgebase, Prompt } from '../../../../Types';
import TabSection from './TabSection';
import TabHeadline from './TabHeadline';
import CheckIcon from '../../../Utility/CheckIcon';
import InfoButton from '../../../Utility/InfoButton';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { knowledgebaseService } from '../../../../Services/knowledgebaseService';
import PaginatedView from '../../../Utility/PaginatedView';

interface KnowledgebaseProps {
    userPrompt: boolean;
    prompt: Prompt;
    i18n: any;
    PromptActions: any;
}

function KnowledgebaseTab({ userPrompt, prompt, i18n, PromptActions }: KnowledgebaseProps) {
    return (
        <div className="w-full">
            <TabHeadline
                title={i18n.translate({
                    id: 'tabs.knowledgebase.title',
                    sourceName: 'Prompt',
                })}
            />
            <InfoButton configKey="knowledgebase" />

            {!userPrompt && (
                <TabSection
                    title={i18n.translate({
                        id: 'tabs.knowledgebase.section.knowledgebase.title',
                        sourceName: 'Prompt',
                    })}
                    subline={i18n.translate({
                        id: 'tabs.knowledgebase.section.knowledgebase.subtitle',
                        sourceName: 'Prompt',
                    })}
                >
                    <PaginatedView
                        listType={PaginationListType.Knowledgebases}
                        itemsFunction={knowledgebaseService.getKnowledgebasesByPage}
                        itemsPerPage={12}
                        renderItem={(knowledgebase: Knowledgebase) => (
                            <KnowledgebaseItem
                                key={knowledgebase.identifier}
                                knowledgebase={knowledgebase}
                                handleChangeFunction={() => {
                                    PromptActions.handleKnowledgebaseCheckboxChange({
                                        target: {
                                            checked: !prompt.knowledgebases.includes(knowledgebase.identifier),
                                            name: knowledgebase.identifier,
                                        },
                                    } as React.ChangeEvent<HTMLInputElement>);
                                }}
                                isActive={prompt.knowledgebases.includes(knowledgebase.identifier)}
                            />
                        )}
                        listClassName="grid grid-cols-[repeat(auto-fill,minmax(theme(spacing.60),1fr))] gap-3"
                    >
                        {({ list, filter }) => (
                            <>
                                {filter}
                                {list}
                            </>
                        )}
                    </PaginatedView>
                </TabSection>
            )}
        </div>
    );
}

export default KnowledgebaseTab;

function KnowledgebaseItem({ knowledgebase, handleChangeFunction, isActive }: any) {
    return (
        <div
            className={`relative border-[2px] p-6 w-full overflow-hidden rounded-xl cursor-pointer hover:border-primary transition-all duration-150 ${
                isActive ? 'border-primary' : 'border-layout-borderColor'
            }`}
            onClick={() => handleChangeFunction(knowledgebase.identifier)}
        >
            <div>
                <p className="p-0 m-0 pr-5 mb-2 text-layout-textcolor text-wrap break-words w-full line-clamp-1">
                    {knowledgebase.name}
                </p>
                <span className="text-xs text-gray-500 line-clamp-2">{knowledgebase.description}</span>
            </div>

            {isActive && <CheckIcon />}
        </div>
    );
}
